import { Strategy } from '@oai-frontend-monorepo/types';

export const strategyIsCredit = (strategy?: Strategy) => {
  switch (strategy) {
    case Strategy.SHORT_PUT:
    case Strategy.SHORT_PUT_SPREAD:
    case Strategy.SHORT_CALL_SPREAD:
    case Strategy.IRON_CONDOR:
    case Strategy.IRON_BUTTERFLY: {
      return true;
    }

    default: {
      return false;
    }
  }
};
